import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import BrandTooltip from 'components/consumer/BrandTooltip';
import PDPNotification from 'components/consumer/PDP/PDPNotification';
import IconQuickship from 'components/icons/iconQuickship';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import { PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePDPLeadTime from 'data-hooks/usePDPLeadTime';
import useScreen from 'hooks/useScreen';
import BrowserOnly from 'components/consumer/BrowserOnly';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import PDPZipCodeEditLocation from '../PDPZipCodeEditLocation';
const PDPLeadTimeUI = t0 => {
  const $ = _c(41);
  const {
    mode
  } = t0;
  const {
    shippingLeadTime,
    leadTimeLoading
  } = usePDPLeadTime();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const userLocation = useUserLocation();
  const isUserInUS = userLocation?.country === "United States";
  const zipCodeFromUser = useZipCodeFromUser();
  const isRTS = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  const isDL = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const [showMobileTooltip, setShowMobileTooltip] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isTooltipOpen => {
      setShowMobileTooltip(isTooltipOpen);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onTooltipToggle = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowMobileTooltip(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeTooltip = t2;
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  const isUnavailableToShip = !!zipCodeFromUser && !isZipCodeFromUserServiceable;
  let t3;
  if ($[2] !== isUnavailableToShip || $[3] !== zipCodeFromUser) {
    t3 = isUnavailableToShip && <span>Unavailable to ship to {zipCodeFromUser}.</span>;
    $[2] = isUnavailableToShip;
    $[3] = zipCodeFromUser;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isDL || $[6] !== isRTS || $[7] !== isUnavailableToShip || $[8] !== leadTimeLoading || $[9] !== shippingLeadTime) {
    t4 = !isUnavailableToShip && (!!leadTimeLoading || !!shippingLeadTime) && <>{!!isRTS && <span className="flex items-center mr-[2px]"><IconQuickship />{" "}</span>}<span className="mr-[3px] text-gray">{isRTS ? "Ready to ship " : isDL ? "Ship time" : "Available to ship "}</span></>;
    $[5] = isDL;
    $[6] = isRTS;
    $[7] = isUnavailableToShip;
    $[8] = leadTimeLoading;
    $[9] = shippingLeadTime;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isUnavailableToShip || $[12] !== leadTimeLoading) {
    t5 = !isUnavailableToShip && !!leadTimeLoading && <BrowserOnly><ProgressLoaderDots inline={true} grey={true} className="m-0 mx-1" /></BrowserOnly>;
    $[11] = isUnavailableToShip;
    $[12] = leadTimeLoading;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isDL || $[15] !== isUnavailableToShip || $[16] !== leadTimeLoading || $[17] !== shippingLeadTime) {
    t6 = !isUnavailableToShip && !leadTimeLoading && !!shippingLeadTime && <span>{isDL ? "TBD" : `in ${shippingLeadTime}`}</span>;
    $[14] = isDL;
    $[15] = isUnavailableToShip;
    $[16] = leadTimeLoading;
    $[17] = shippingLeadTime;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span> </span>;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isUnavailableToShip || $[21] !== isUserInUS || $[22] !== leadTimeLoading || $[23] !== shippingLeadTime) {
    t8 = (isUnavailableToShip || !isUnavailableToShip && (!!leadTimeLoading || !!shippingLeadTime) || !isUserInUS) && <PDPZipCodeEditLocation />;
    $[20] = isUnavailableToShip;
    $[21] = isUserInUS;
    $[22] = leadTimeLoading;
    $[23] = shippingLeadTime;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== isUnavailableToShip || $[26] !== mode) {
    t9 = !isUnavailableToShip && <div><BrandTooltip className="bottom-0.5" direction={mode === "quickview" ? "top" : "bottom"} hideIconOnOpenMobile={true} iconClassName="!top-[3px]" iconSize="big" inactiveOnMobile={true} mode={mode} onTooltipToggle={onTooltipToggle} openOnHover={true} showCloseButton={false}>{"Please note, this is the estimated time it will take to build and prepare your order for shipment. This is not a delivery date. Full delivery estimates are shown once you're done adding products to your order at checkout."}</BrandTooltip></div>;
    $[25] = isUnavailableToShip;
    $[26] = mode;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t8 || $[33] !== t9) {
    t10 = <div className="flex flex-row items-center min-h-[15px] mt-4 justify-center text-gray text-base text-ellipsis whitespace-nowrap flex-wrap max-[767px]:[justify-content:left] max-[767px]:mr-0">{t3}{t4}{t5}{t6}{t7}{t8}{t9}</div>;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== isMobileOrTablet || $[36] !== showMobileTooltip) {
    t11 = showMobileTooltip && isMobileOrTablet && <PDPNotification heading="Ready to Ship" subheading="Please note, this is the estimated time it will take to build and prepare your order for shipment. This is not a delivery date. Full delivery estimates are shown once you're done adding products to your order at checkout." onClose={closeTooltip} />;
    $[35] = isMobileOrTablet;
    $[36] = showMobileTooltip;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t10 || $[39] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
};
PDPLeadTimeUI.propTypes = {
  mode: PropTypes.oneOf(['quickview', 'pdp'])
};
export default PDPLeadTimeUI;